"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../schema");
const value = schema_1.Schema.number()
    .unit("G/l")
    .precision(2)
    .min(0)
    .max(100000)
    .interpretation({ vocab: "basic_health", code: "fvs" })
    .tag({ vocab: "snomed", code: "767002" })
    .tag({ vocab: "loinc", code: "6690-2" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "396550006" })
    .tag({ vocab: "loinc", code: "55429-5" })
    .tag({ vocab: "basic_health", code: "lab_bloodcount" });
